import * as React from "react"
const SvgRecList = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.5 8.929a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.286h10q.424 0 .712.287.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm-.713 3.712q.288.288.713.288h10q.424 0 .712-.288a.97.97 0 0 0 .288-.712.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-10a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712m0 4q.288.288.713.288h6a.97.97 0 0 0 .713-.288.97.97 0 0 0 .287-.712.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287h-6a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712m10.162 3.788a.91.91 0 0 1-.67-.28.91.91 0 0 1-.279-.669v-2.846q0-.143.06-.273a.8.8 0 0 1 .153-.225l1.495-1.494a.72.72 0 0 1 .498-.213q.308 0 .533.237t.166.604l-.154.89h2.466q.202 0 .338.136a.46.46 0 0 1 .137.338v.593a.8.8 0 0 1-.048.26l-1.067 2.515a.65.65 0 0 1-.267.314.75.75 0 0 1-.397.113z" />
  </svg>
)
export default SvgRecList
